import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=a86fd934&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a86fd934')) {
      api.createRecord('a86fd934', component.options)
    } else {
      api.reload('a86fd934', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=a86fd934&", function () {
      api.rerender('a86fd934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/Pagination.vue"
export default component.exports